// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.first {
  margin-top: 1em;
}

.marging-child > * {
  margin-right: 1em;
}

.fusion {
  margin-bottom: 0.5em;
  margin-left: 0.5em;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImdyb3VwLWV0bC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFSTtFQUNJLGVBQUE7QUFEUjs7QUFLSTtFQUNJLGlCQUFBO0FBRlI7O0FBS0k7RUFDSSxvQkFBQTtFQUNBLGtCQUFBO0FBRlIiLCJmaWxlIjoiZ3JvdXAtZXRsLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG4gICAgXG4gICAgLmZpcnN0e1xuICAgICAgICBtYXJnaW4tdG9wOiAxZW07XG4gICAgfVxuXG5cbiAgICAubWFyZ2luZy1jaGlsZCA+ICoge1xuICAgICAgICBtYXJnaW4tcmlnaHQ6IDFlbTtcbiAgICB9XG5cbiAgICAuZnVzaW9ue1xuICAgICAgICBtYXJnaW4tYm90dG9tOiAwLjVlbTtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDAuNWVtO1xuICAgIH0iXX0= */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/etl-v1/etl-update/etl-update-filter/group-etl/group-etl.component.scss"],"names":[],"mappings":"AAEI;EACI,eAAA;AADR;;AAKI;EACI,iBAAA;AAFR;;AAKI;EACI,oBAAA;EACA,kBAAA;AAFR;AACA,olBAAolB","sourcesContent":["\n    \n    .first{\n        margin-top: 1em;\n    }\n\n\n    .marging-child > * {\n        margin-right: 1em;\n    }\n\n    .fusion{\n        margin-bottom: 0.5em;\n        margin-left: 0.5em;\n    }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
